// we will use just ASYNC_REQUEST and ASYNC_FAIL wrappers,
// so we can listen to normal *_SUCCESS in reducers

// action types
export const ASYNC_REQUEST = 'ASYNC_REQUEST'
export const ASYNC_SUCCESS = 'ASYNC_SUCCESS'
export const ASYNC_FAIL = 'ASYNC_FAIL'
export const ASYNC_MESSAGE_CLEAN = 'ASYNC_MESSAGE_CLEAN'

// action creators
export const asyncRequest = (actionName, requestPayload) => ({
  type: ASYNC_REQUEST,
  payload: { ...requestPayload, actionName }
})

export const asyncSuccess = (actionName, successPayload, message) => ({
  type: ASYNC_SUCCESS,
  payload: { ...successPayload, actionName, message }
})

export const asyncFail = (actionName, message) => ({
  type: ASYNC_FAIL,
  payload: { actionName, message }
})

export const cleanMessages = () => ({
  type: ASYNC_MESSAGE_CLEAN
})



// WEBPACK FOOTER //
// ./src/actions/async.js